import styled from '@emotion/styled';

const FieldContainer = styled.div`
    padding: 0 16px;
    margin: 16px 0;

    input {
        margin-top: 4px;
        width: calc(100% - 32px);
    }
`;

export default FieldContainer;
